import React, { forwardRef, useImperativeHandle, useState } from 'react';

const NOT_AVAILABLE_TEXT = 'N/A';
const TOOLTIP_OFFSET = 10;

const LocationTooltip = forwardRef((_, ref) => {
  const [content, setContent] = useState(null);
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useImperativeHandle(ref, () => ({
    update: data => {
      setContent(data);
      setVisible(true);
    },
    hide: () => setVisible(false),
    setPosition: (top, left) => setPosition({ top, left })
  }));

  const orgUnitsTextList = getOrgUnitsTextList(content?.locationData);

  return (
    <div
      ref={ref}
      data-testid='location-chart-tooltip'
      className='recharts-tooltip-wrapper'
      style={{
        top: `${position.top + TOOLTIP_OFFSET}px`,
        left: `${position.left + TOOLTIP_OFFSET}px`,
        display: visible ? 'block' : 'none'
      }}>
      <div className='tooltip'>
        <strong>{content?.name}</strong>
        {orgUnitsTextList.map((label, index) => (
          <div key={index}>{label}</div>
        ))}
      </div>
    </div>
  );
});

const getOrgUnitsTextList = locationData =>
  locationData?.orgUnits.map(x => `${x.name} - ${x.fei}`) || [NOT_AVAILABLE_TEXT];

LocationTooltip.displayName = 'LocationTooltip';

export default LocationTooltip;
